module.exports = __webpack_public_path__ + "img/w3_circle_grid_white.3ef6f218.3ef6f218.png";